import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en.js";
import es from "./es.js";
import de from "./de.js";
import fr from "./fr.js";
import pt from "./pt.js";
import { ES_ANALITICS, EN_ANALITICS, PT_ANALITICS } from "@/serviforms/analitics/i18n";
import { ES_ACCESTOKEN, EN_ACCESTOKEN, PT_ACCESTOKEN } from "@/serviforms/accessTokens/i18n";
import { ES_COMPANIES, EN_COMPANIES, PT_COMPANIES } from "@/serviforms/Companies/i18n";
import { ES_MULTIFORMS, EN_MULTIFORMS, PT_MULTIFORMS } from "@/serviforms/MultiForms/i18n";
import { ES_GROUPVIEW, EN_GROUPVIEW, PT_GROUPVIEW } from "@/serviforms/Groups/i18n";
import { ES_USERSVIEW, EN_USERSVIEW, PT_USERSVIEW } from "@/serviforms/users/i18n";
import { ES_VISITSVIEW, EN_VISITSVIEW, PT_VISITSVIEW } from "@/serviforms/visits/i18n";
import { ES_FORMS, EN_FORMS, PT_FORMS } from "@/serviforms/forms/i18n";
import { ES_PROFILEVIEW, EN_PROFILEVIEW, PT_PROFILEVIEW } from "@/serviforms/profile/i18n";
import { ES_DATASOURCEVIEW, EN_DATASOURCEVIEW, PT_DATASOURCEVIEW } from "@/serviforms/Datasource/i18n";
import { ES_CONNECTIONSVIEW, EN_CONNECTIONSVIEW, PT_CONNECTIONSVIEW } from "@/serviforms/connections/i18n"
import { ES_TRANSFERVIEW, EN_TRANSFERVIEW, PT_TRANSFERVIEW } from "@/serviforms/TransferForms/i18n"
import { ES, EN, PT } from "@/serviforms/designer/i18n";

const messages = {
  en: {
    ...en,
    ...EN,
    ...EN_ANALITICS,
    ...EN_ACCESTOKEN,
    ...EN_COMPANIES,
    ...EN_FORMS,
    ...EN_MULTIFORMS,
    ...EN_GROUPVIEW,
    ...EN_USERSVIEW,
    ...EN_VISITSVIEW,
    ...EN_PROFILEVIEW,
    ...EN_DATASOURCEVIEW,
    ...EN_CONNECTIONSVIEW,
    ...EN_TRANSFERVIEW
  },
  es: {
    ...es,
    ...ES,
    ...ES_ANALITICS,
    ...ES_ACCESTOKEN,
    ...ES_COMPANIES,
    ...ES_FORMS,
    ...ES_MULTIFORMS,
    ...ES_GROUPVIEW,
    ...ES_USERSVIEW,
    ...ES_VISITSVIEW,
    ...ES_PROFILEVIEW,
    ...ES_DATASOURCEVIEW,
    ...ES_CONNECTIONSVIEW,
    ...ES_TRANSFERVIEW
  },
  de,
  fr,
  pt: {
    ...pt,
    ...PT,
    ...PT_ANALITICS,
    ...PT_ACCESTOKEN,
    ...PT_COMPANIES,
    ...PT_FORMS,
    ...PT_MULTIFORMS,
    ...PT_GROUPVIEW,
    ...PT_USERSVIEW,
    ...PT_VISITSVIEW,
    ...PT_PROFILEVIEW,
    ...PT_DATASOURCEVIEW,
    ...PT_CONNECTIONSVIEW,
    ...PT_TRANSFERVIEW
  }
};

Vue.use(VueI18n);

export default new VueI18n({
  locale: "es",
  messages,
  silentTranslationWarn: process.env.NODE_ENV === "production"
});
